<template>
  <div>
    <form
      v-on:submit.prevent="doLogin"
      class="login-form"
      v-bind:class="{ 'form--inverse': darkTheme }">
      <label-input
        v-model="credentials.username"
        :error="loginErrorUserNotFound"
        :errorMessage="$t('login.userErrorMessage')"
        :label="$t('login.userLabel')"
        :placeholder="$t('login.userPlaceholder')">
      </label-input>
      <label-input
        v-model="credentials.password"
        :error="loginErrorWrongPassword || loginErrorExpiredLicense"
        :errorMessage="fieldErrorMessage"
        type="password"
        :label="$t('login.password')"
        :placeholder="$t('login.passwordPlaceholder')">
      </label-input>

      <grid-row>
        <grid-col col-size="3">
          <btn-pill
            type="submit"
            :btnText="$t('login.enter')"
            btn-size="m">

          </btn-pill>
        </grid-col>
        <grid-col class="center-content" col-size="2">
          <div class="pointer red-text">
            <span @click='createAccount()'>{{ $t('signin.noAccountCreate') }}</span>
          </div>
        </grid-col>
      </grid-row>
    </form>
  </div>
</template>

<script>

import LabelInput from '@/components/shared/forms/LabelInput';
import BtnPill from '@/components/shared/buttons/BtnPill';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck';
import {mapGetters, mapActions} from 'vuex';
import variables from '../../stylesheets/_variables.scss';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';

export default {
  name: 'LoginForm',
  components: {
    GridCol,
    GridRow,
    LabelInput,
    BtnPill,
    FontAwesomeIcon
  },
  data () {
    return {
      credentials: {
        username: '',
        password: ''
      },
      darkTheme: variables.theme === '"dark"',
      label: ''
    };
  },
  computed: {
    ...mapGetters([
      'loginErrorUserNotFound',
      'loginErrorWrongPassword',
      'loginErrorExpiredLicense'
    ]),
    check () {
      return faCheck;
    },
    fieldErrorMessage () {
      if (this.loginErrorWrongPassword) {
        return this.$t('login.passwordErrorMessage');
      }
      return this.$t('health.login.licenseError');
    }

  },
  methods: {
    ...mapActions([
      'setLocale',
      'login'
    ]),
    doLogin () {
      const credentials = {
        username: this.credentials.username,
        password: this.credentials.password
      };
      const path = this.$route.query.path ? this.$route.query.path : '/';
      this.login({
        context: this,
        credentials: credentials,
        path: path
      });
    },
    createAccount () {
      this.$emit('createAccount');
    }
  }
};

</script>

<style scoped lang="scss">
@import "src/stylesheets/variables";

.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.red-text {
  color: $primary;
  font-weight: bold;
}

span:hover {
  cursor: pointer;
}
@import "src/stylesheets/variables";
.login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  &:after {
    content: "";
    background-size: auto 100%;
    position: absolute;
    top: 13%;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    opacity: 1;
    @media (min-width: $screen-l) {
      background: no-repeat left center url(~BRAND/assets/login-bg.jpg);
      z-index: -3;
      background-position: left top;
      background-size: auto;
    }
  }
  &__bg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    background-color: $login-background;
    @media (min-width: $screen-l) {
      background-color: transparent;
      background-image: radial-gradient(
          circle at 23% 35%,
          rgba($login-background, 0.5),
          rgba($login-background, 0.6),
          rgba($login-background, 0.9),
          $login-background 35%,
          $login-background
      );
    }
    @include brandCustom-loginBg();
    &:before {
      content: "";
      width: 100%;
      height: 100%;
      background-image: url($brandImage-LoginBgBefore);
      background-repeat: no-repeat;
      background-position: right bottom;
      position: absolute;
      right: 0;
      top: 0;
      opacity: 0.4;
      z-index: 0;
      @include brandCustom-loginBgBefore();
    }
  }
  &__content {
    color: $login-text-color;
    @media (max-width: $screen-l-max) {
      padding: 0 $sp-margin-large;
    }
    @media (min-width: $screen-l) {
      display: flex;
    }
  }
  &__brand {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: $sp-margin-larger;
    @media (max-width: $screen-l-max) {
      margin-top: $sp-margin-large;
      flex-direction: row;
      max-width: ($sp * 80) + $sp-margin-larger;
      padding-right: 0;
      margin-bottom: $sp-margin;
    }
  }
  &__form {
    max-width: ($sp * 80) + $sp-margin-larger;
    @media (min-width: $screen-l) {
      padding-left: $sp-margin-larger;
      border-left: 1px solid $login-form-right-border;
    }
    form {
      margin-bottom: $sp-margin;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/auth/LoginForm.vue